import { COURSES_SECTION_INPUTS } from "./CoursesSection";
import { GENERAL_SECTION_INPUTS } from "./GeneralDataSection";
import { INITIAL_TRAIL_SECTION_INPUTS } from "./InitialTrailSection";
import { MANAGER_SECTION_INPUTS } from "./ManagerSection";
import { THEME_SECTION_INPUTS } from "./ThemeSection";

export const defaultFormValues = {
  [GENERAL_SECTION_INPUTS.COMPANY_NAME]: '',
  [GENERAL_SECTION_INPUTS.DESCRIPTION]: 'Programa de formação de colaboradores',
  [GENERAL_SECTION_INPUTS.TOTAL_LICENSES]: 0,
  [GENERAL_SECTION_INPUTS.TOTAL_COLLABORATORS]: 0,
  [GENERAL_SECTION_INPUTS.MANAGER_EMAIL]: '',
  [GENERAL_SECTION_INPUTS.URL]: '',
  [GENERAL_SECTION_INPUTS.ACCESS_PERIOD]: '',
  [GENERAL_SECTION_INPUTS.IS_ACTIVE]: true,
  [GENERAL_SECTION_INPUTS.STATUS]: 'active',
  [GENERAL_SECTION_INPUTS.RESTRICTED_COURSES]: 'no',
  [MANAGER_SECTION_INPUTS.NEW_MANAGER_NAME]: '',
  [MANAGER_SECTION_INPUTS.NEW_MANAGER_EMAIL]: '',
  [MANAGER_SECTION_INPUTS.MANAGERS]: [],
  [MANAGER_SECTION_INPUTS.MANAGERS_EMAILS_TO_REMOVE]: [],
  [COURSES_SECTION_INPUTS.COURSES]: [],
  [INITIAL_TRAIL_SECTION_INPUTS.TRAIL_NAME]: '',
  [INITIAL_TRAIL_SECTION_INPUTS.TRAIL_DESCRIPTION]: '',
  [INITIAL_TRAIL_SECTION_INPUTS.TRAIL_COURSE_IDS]: '2066,5120,5688,5689',
  [THEME_SECTION_INPUTS.COMPANY_LOGO]: {
    imageFile: '',
    url: ''
  },
  [THEME_SECTION_INPUTS.COMPANY_LOGIN_IMAGE]: {
    imageFile: '',
    url: ''
  },
  [THEME_SECTION_INPUTS.COMPANY_COLORS]: [
    {
      value: '#0F7DE2',
      name: '(primária)',
    },
    {
      value: '#FFFCEC',
      name: '(secundária)',
    },
  ],
}